/* unplugin-vue-components disabled */import { render } from "./loginResult.vue?vue&type=template&id=7e61d5ec&scoped=true"
import script from "./loginResult.vue?vue&type=script&lang=js"
export * from "./loginResult.vue?vue&type=script&lang=js"

import "./loginResult.vue?vue&type=style&index=0&id=7e61d5ec&scoped=true&lang=css"

import exportComponent from "/data/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e61d5ec"]])

export default __exports__